import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { iaRa } from 'lib/helpers/utility';

import { groupInvoices } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceContent/lib/helpers';
import InvoiceTable from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/InvoiceTable';
import { INVOICE_COLUMN_DEFS } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/lib/columnDefs';
import { formatInvoiceProcedures } from 'components/practice/BeyondBilling/ElectronicInvoicing/lib/formatInvoiceProcedures';
import { getInvoiceDetails } from 'components/practice/BeyondBilling/ElectronicInvoicing/lib/internal/configs';
import { currentPractice } from 'components/practice/practiceState';

const Invoices = ({ invoices, hiddenFields }) => {
  const practice = useRecoilValue(currentPractice);
  const claims = practice?.display_settings?.claims;
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const invoiceDetails = useMemo(
    () => iaRa(invoices).flatMap((invoice) => getInvoiceDetails(invoice, claims)),
    [invoices, claims]
  );

  const rowData = useMemo(
    () => formatInvoiceProcedures({ invoices: invoiceDetails }),
    [invoiceDetails]
  );

  const gridData = useMemo(() => groupInvoices(iaRa(rowData)), [rowData]);

  const columnDefs = useMemo(
    () => INVOICE_COLUMN_DEFS(isMobile).filter((column) => !hiddenFields?.includes?.(column.field)),
    [isMobile, hiddenFields]
  );

  return (
    <div className="px-6 sm:px-0">
      <InvoiceTable preview columnDefs={columnDefs} rowData={Object.values(gridData)} footer />
    </div>
  );
};

export default Invoices;
